var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1213_329672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19644 12.7225C0.583757 11.6564 0.583757 10.3436 1.19644 9.27754L5.11242 2.46359C5.7267 1.39472 6.86294 0.736927 8.09179 0.736927L15.9082 0.736927C17.1371 0.736927 18.2733 1.39472 18.8876 2.46359L22.8036 9.27755C23.4162 10.3436 23.4162 11.6564 22.8036 12.7225L18.8876 19.5364C18.2733 20.6053 17.1371 21.2631 15.9082 21.2631L8.09179 21.2631C6.86294 21.2631 5.7267 20.6053 5.11242 19.5364L1.19644 12.7225Z",
    stroke: "#E9BE5C",
    strokeWidth: 1.47386
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_329672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7341 15.3392C10.5776 15.5205 10.585 15.7953 10.7564 15.9677C10.846 16.058 10.9641 16.1033 11.0818 16.1033C11.1995 16.1033 11.3175 16.058 11.4072 15.9677L12.1663 15.2036C12.2523 15.1171 12.3006 14.9997 12.3006 14.8773C12.3006 14.7548 12.2522 14.6379 12.1665 14.5512L12.1663 14.551L11.4072 13.787C11.2276 13.6062 10.9359 13.6062 10.7564 13.787C10.585 13.9594 10.5776 14.2342 10.7341 14.4155H9.33385C9.15749 14.4155 9.01233 14.2706 9.01233 14.091V10.8164C10.3932 10.5939 11.4504 9.38731 11.4504 7.93749C11.4504 6.33027 10.1512 5.02168 8.5526 5.02168C6.95396 5.02168 5.65486 6.33054 5.65486 7.93749C5.65486 9.38755 6.7122 10.5941 8.09288 10.8164V14.091C8.09288 14.7784 8.64876 15.3392 9.33385 15.3392H10.7341ZM6.57431 7.93749C6.57431 6.83832 7.4627 5.94539 8.5526 5.94539C9.64251 5.94539 10.5309 6.83832 10.5309 7.93749C10.5309 9.03665 9.64251 9.92959 8.5526 9.92959C7.4627 9.92959 6.57431 9.03665 6.57431 7.93749Z",
    fill: "#E9BE5C",
    stroke: "#E9BE5C",
    strokeWidth: 0.26841
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6646 7.47582H13.2644C13.4208 7.29451 13.4134 7.01973 13.2421 6.8473C13.0625 6.66656 12.7708 6.66656 12.5913 6.8473L11.8321 7.61137C11.7461 7.69793 11.6978 7.81532 11.6978 7.93767C11.6978 8.06019 11.7462 8.17715 11.8319 8.26377L11.8319 8.26377L11.8321 8.26397L12.5913 9.02805C12.6809 9.11831 12.799 9.1636 12.9167 9.1636C13.0344 9.1636 13.1524 9.11831 13.2421 9.02805C13.4134 8.85562 13.4208 8.58084 13.2644 8.39952H14.6646C14.8409 8.39952 14.9861 8.54438 14.9861 8.72403V11.9986C13.6052 12.2211 12.5481 13.4277 12.5481 14.8775C12.5481 16.4847 13.8472 17.7933 15.4458 17.7933C17.0445 17.7933 18.3436 16.4845 18.3436 14.8775C18.3436 13.4275 17.2862 12.2209 15.9056 11.9986V8.72403C15.9056 8.03659 15.3497 7.47582 14.6646 7.47582ZM15.4458 16.8696C14.3559 16.8696 13.4675 15.9767 13.4675 14.8775C13.4675 13.7784 14.3559 12.8854 15.4458 12.8854C16.5357 12.8854 17.4241 13.7784 17.4241 14.8775C17.4241 15.9767 16.5357 16.8696 15.4458 16.8696Z",
    fill: "#E9BE5C",
    stroke: "#E9BE5C",
    strokeWidth: 0.26841
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1213_329672",
    x: -12.1347,
    y: -12.1347,
    width: 48.2693,
    height: 46.2693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.06733
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1213_329672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1213_329672",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.86687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1213_329672"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1213_329672",
    result: "effect3_innerShadow_1213_329672"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_329672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.4205,
    fill: "white",
    transform: "translate(5.33203 4.69714)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.f783e0fb5b9ce928e55e01bd0397018e.svg";
export { ForwardRef as ReactComponent };